import styled from 'styled-components';
import { Button as AntButton } from 'antd';

export const Container = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  gap: 8px;
  background-color: transparent;
`;

export const LeftPanel = styled.div<{ $transitionEnabled?: boolean }>`
  position: relative;
  overflow: auto;
  flex: 0 0 var(--left-panel-width);
  inline-size: var(--left-panel-width);
  transition: ${({ $transitionEnabled }) =>
    $transitionEnabled ? 'inline-size 200ms ease, flex-basis 200ms ease' : 'none'};
`;

export const RightPanel = styled.div`
  flex: auto;
  min-width: 0;
  overflow: auto;
`;

export const LeftContainer = styled.div`
  height: 100%;
  overflow: auto;
`;

export const Dragger = styled.div<{ $isLazyDragging?: boolean; $hidden?: boolean }>`
  visibility: ${({ $hidden }) => ($hidden ? 'hidden' : 'visible')};
  position: absolute;
  inset: 0 -8px 0 var(--left-panel-width);
  width: 8px;
  background-color: transparent;
  cursor: col-resize;

  &:hover {
    &::after {
      visibility: visible;
      background: rgb(0 0 0 / 35%);
    }
  }

  &::before {
    content: '';
    visibility: ${({ $isLazyDragging }) => ($isLazyDragging ? 'visible' : 'hidden')};
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    transform: translateX(calc(-50% + var(--preview-offset, 0px)));
    width: 2px;
    background: #0046ff;
    opacity: 0.2;
    pointer-events: none;
    z-index: 100;
  }

  &::after {
    content: '';
    width: 2px;
    height: 20px;
    background: rgb(0 0 0 / 15%);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const ToggleButton = styled(AntButton)`
  position: absolute;
  top: 30px;
  right: 6px;
  transform: translateY(-50%);
  color: #b8b8b8;
  z-index: 100;
`;
